import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, List, ModalHeader, Typography } from 'common/components';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../../../interior-doors-constants';

const freeMeasurementText = css`
  margin-bottom: 8px;
`;

const freeMeasurementModalList = css`
  && {
    margin-bottom: 8px;

    li {
      margin-bottom: 4px;

      @media (--from-tablet) {
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
`;

type FreeMeasurementProps = {
  onConsultationSignupBtnClick: () => void;
};

export const FreeMeasurement = ({ onConsultationSignupBtnClick }: FreeMeasurementProps) => (
  <>
    <ModalHeader title="Консультация и запись на&nbsp;замер" />
    <ModalContent>
      <Typography className={freeMeasurementText} variant="m" size="body_long">
        Наши специалисты подробно проконсультируют и&nbsp;оформят услугу замера. Поможем подобрать дверь
        и&nbsp;все товары, необходимые для монтажа:
      </Typography>
      <List className={freeMeasurementModalList} listStyle="disc">
        <li>
          <Typography variant="m" size="body_long">
            дверной погонаж (наличники, дверную коробку, доборные планки);
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            дверные ручки;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            петли;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            замки и завёртки;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            порожки.
          </Typography>
        </li>
      </List>
      <Typography variant="m" size="body_long">
        Вернём деньги за&nbsp;замер! Просто закажите услугу установки у&nbsp;наших специалистов.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
        elementName="Записаться на консультацию"
        elementText="Бесплатный замер и консультация"
        onClick={onConsultationSignupBtnClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
